export default {
	data(){
		return {
			tableGBoptions: { 
				options: {editar: 'Editar Proveedor de Montura', inactivar: 'Inactivar Proveedor de Montura'},
				modals: []
			},

			tableGBSearch: ['datos_proveedores_montura/documento','datos_proveedores_montura/name'],
			
			tableGBItems: [
				{
					thead: { th: 'Nit', sort: null, sortTable: 'datos_proveedores_montura/documento'},
					tbody: { td: ['datos_proveedores_montura/documento']}
				},
				{
					thead: { th: 'Proveedor', sort: null, sortTable: 'datos_proveedores_montura/name'},
					tbody: { td: ['datos_proveedores_montura/name'],}
				},
				{
					thead: { th: 'Telefonos', },
					tbody: { td: ['datos_proveedores_montura/telefonos'],}
				},
				{
					thead: { th: 'Direccion', },
					tbody: { td: ['datos_proveedores_montura/direccion'],}
				},
				{
					thead: { th: 'Contacto', },
					tbody: { td: ['datos_proveedores_montura/contacto'],}
				},
			]
			
		}
	},
}